<template>
  <CSidebar
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none" to="/">
      <!-- <CIcon
        class="c-sidebar-brand-full"
        name="logo"
        id="logo-main"
        size="custom-size"
        :height="56"
        viewBox="0 0 556 134"
      />
      <CIcon
        class="c-sidebar-brand-minimized"
        name="logo"
        size="custom-size"
        :height="35"
        viewBox="0 0 110 134"
      />-->
      <div
        class="m-auto logo-temp text-uppercase text-center w-100"
        :class="[{ 'd-none': minimize }]"
      >
        <div
          class="imgLogo"
          v-bind:style="{
            'background-image': 'url(' + imgLogo + ')',
          }"
        ></div>
      </div>
    </CSidebarBrand>
    <div class="text-center mt-2 pt-2" :class="[{ 'd-none': minimize }]">
      <div
        class="img-profile"
        v-bind:style="{
          'background-image': 'url(' + profileInfo.seller.logo + ')',
        }"
      ></div>
      <h4 class="font-weight-bold mt-2 username" v-if="profileInfo.displayNameTranslation.length > 0">
        {{ profileInfo.displayNameTranslation[$language == "th" ? 0 : 1].name }}
      </h4>

      <b-row class="no-gutters py-3 user-btn mt-4">
        <b-col v-if="!profileInfo.isAdmin">
          <router-link :to="'/profile/general'" class="text-white no-underline">
            <div>
              <font-awesome-icon icon="user" />
            </div>
            <p class="m-0">{{ $t("profile") }}</p>
          </router-link>
        </b-col>
        <b-col class="pointer" @click.prevent="handleLogout">
          <div>
            <font-awesome-icon icon="power-off" />
          </div>
          <p class="m-0">{{ $t("logout") }}</p>
        </b-col>
      </b-row>
    </div>
    <!-- <div> -->

    <CRenderFunction flat :contentToRender="sidebarItems" />
    <!-- </div> -->
    <CSidebarMinimizer
      class="c-d-md-down-none"
      @click.native="$store.commit('toggle', 'sidebarMinimize')"
    />

    <ModalAlertConfirm
      :msg="$t('logout')"
      :text="modalMessage"
      colorBtnConfirm="primary"
      :btnCancel="$t('no')"
      :btnConfirm="$t('yes')"
      ref="isModalAlertConfirm"
      @confirm="logout"
    />

    <ModalLoading ref="modalLoading" :hasClose="false" />
  </CSidebar>
</template>

<script>
import SidebarItems from "./SidebarItems";
import blankProfile from "@/assets/images/icons/user.png";
import { mapState } from "vuex";
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
import ModalLoading from "@/components/modal/alert/ModalLoading";

export default {
  name: "TheSidebar",
  extends: SidebarItems,
  components: {
    ModalAlertConfirm,
    ModalLoading,
  },
  data() {
    return {
      modalMessage: `${this.$t("logoutMsg")}`,
      name: "",
      lastname: "",
      img: "",
      imgLogo: "",
      blankProfile: blankProfile,
    };
  },
  computed: {
    show() {
      return this.$store.state.sidebarShow;
    },
    ...mapState({
      minimize: (state) => state.sidebarMinimize,
      profileInfo: (state) => state.profile,
    }),
  },
  props: {
    forcerefresh: {
      required: false,
      type: Boolean,
    },
  },
  mounted: async function () {
    this.getProfileInfo();
    this.getLogo();
  },
  methods: {
    handleLogout() {
      this.$refs.isModalAlertConfirm.show();
    },
    logout: async function () {
      this.$refs.isModalAlertConfirm.hide();
      this.$refs.modalLoading.show();

      let resData = await this.$callApi(
        "post",
        `${this.$baseUrl}/api/logout`,
        null,
        this.$headers,
        null
      );

      if (this.$cookies.isKey("seller-token")) {
        let cookiesDomain = window.location.hostname;
        this.$cookies.remove(
          "seller-token",
          null,
          cookiesDomain.replace("www.", "")
        );
      }
      if (this.$cookies.isKey("adminSellerId")) {
        let cookiesDomain = window.location.hostname;
        this.$cookies.remove(
          "adminSellerId",
          null,
          cookiesDomain.replace("www.", "")
        );
      }
      window.location.href = "/login";
    },
    getProfileInfo: async function () {
      await this.$store.dispatch("getUserApi");
      if (!this.profileInfo.seller.logo)
        this.profileInfo.seller.logo = blankProfile;
    },
    getLogo: async function () {
      let resData = await this.$callApi(
        "get",
        `${this.$baseUrl}/api/setting/Logo`,
        null,
        this.$headers,
        null
      );
      this.imgLogo = resData.detail;
      this.$store.commit("setLogoPathUrl", resData.detail);
    },
    handleResize() {
      this.$screenSize.width = window.innerWidth;
      this.$screenSize.height = window.innerHeight;
    },
  },
  async created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style scoped>
#logo-main {
  background-image: url("/img/brand/coreui-base-white.svg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.logo-temp {
  color: #ffb300;
  font-size: 24px;
  font-weight: bold;
}

.user-btn {
  background: #373122;
}

.username {
  font-size: 22px;
}

.img-profile {
  width: 50%;
  padding-bottom: 50%;
  border-radius: 50%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  margin: auto;
}

.w-50px {
  width: 100px;
}
</style>